module.exports = __webpack_public_path__ + "01_face.acbea937.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer1/01_face.png
// module id = XWB5
// module chunks = 0